{
  "INBOX_MGMT": {
    "HEADER": "Sandučići",
    "DESCRIPTION": "Kanal je način komunikacije koji korisnik odabere za interakciju s vama. Sandučić je mjesto gdje upravljate interakcijama za određeni kanal. Može uključivati komunikaciju iz različitih izvora, kao što su e-mail, live chat i društvene mreže.",
    "LEARN_MORE": "Saznajte više o sandučićima",
    "RECONNECT": {
      "BUTTON": "Ponovno poveži",
      "FACEBOOK": "Veza s Facebookom je istekla ili je opozvana. Poruke poslane stranici ne stižu u ovaj sandučić, a odgovori možda neće biti poslani. Osoba koja upravlja Facebook stranicom mora kliknuti Ponovno poveži i prijaviti se na Facebook.",
      "INSTAGRAM": "Veza s Instagramom je istekla ili je opozvana. Poruke poslane na račun ne stižu u ovaj sandučić, a odgovori možda neće biti poslani. Kliknite Ponovno poveži i prijavite se na isti Instagram račun. Drugi račun stvara novi sandučić.",
      "GOOGLE": "Veza s Googleom je istekla ili je opozvana. Nove e-poruke ne stižu u ovaj sandučić, a odgovori možda neće biti poslani. Kliknite Ponovno poveži i prijavite se na Google kao {email}.",
      "MICROSOFT": "Veza s Microsoftom je istekla ili je opozvana. Nove e-poruke ne stižu u ovaj sandučić, a odgovori možda neće biti poslani. Kliknite Ponovno poveži i prijavite se na Microsoft kao {email}.",
      "ALLEGRO": "Veza s Allegrom je istekla ili je opozvana. Poruke kupaca ne stižu u ovaj sandučić, a odgovori možda neće biti poslani. Kliknite Ponovno poveži i prijavite se na Allegro kao prodavatelj {seller}. Drugi račun prodavatelja stvara novi sandučić.",
      "IMAP_LOGIN": "Poslužitelj e-pošte odbija IMAP prijavu {login}. Nove e-poruke ne stižu u ovaj sandučić. Provjerite IMAP korisničko ime i lozinku na kartici {tab} te ih spremite. Nastavljamo pokušavati prijavu, a sandučić će se oporaviti čim prijava proradi.",
      "WHATSAPP": "Veza s WhatsAppom je istekla ili je opozvana. Privitci od kupaca ne stižu u ovaj sandučić, a odgovori mogu ne uspjeti. Kliknite Ponovno poveži, prijavite se na Facebook i ponovno odaberite broj {phone}."
    },
    "LIST": {
      "404": "Ovom računu nisu pridruženi sandučići.",
      "RECONNECT_REQUIRED": "Potrebno je ponovno povezivanje"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Odaberite kanal",
        "BODY": "Odaberite pružatelja usluge kojeg želite integrirati."
      },
      "INBOX": {
        "TITLE": "Kreirajte sandučić",
        "BODY": "Autentificirajte svoj račun i kreirajte sandučić."
      },
      "AGENT": {
        "TITLE": "Dodajte agente",
        "BODY": "Dodajte agente u kreirani sandučić."
      },
      "FINISH": {
        "TITLE": "Gotovo!",
        "BODY": "Sve je spremno!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Naziv sandučića",
        "PLACEHOLDER": "Unesite naziv sandučića (npr. Acme Inc)",
        "ERROR": "Unesite valjani naziv sandučića"
      },
      "WEBSITE_NAME": {
        "LABEL": "Naziv web stranice",
        "PLACEHOLDER": "Unesite naziv web stranice (npr. Acme Inc)"
      },
      "INTERNAL_NAME": {
        "LABEL": "Interno ime",
        "PLACEHOLDER": "Imenujte sandučić kako je prikazan u ovoj kontrolnoj ploči",
        "ERROR": "Unesite jedinstveno interno ime"
      },
      "FB": {
        "HELP": "PS: Prijavom dobivamo pristup samo porukama vaše stranice. Vašim privatnim porukama nikada ne možemo pristupiti.",
        "CHOOSE_PAGE": "Odaberite stranicu",
        "CHOOSE_PLACEHOLDER": "Odaberite stranicu s popisa",
        "INBOX_NAME": "Naziv sandučića",
        "ADD_NAME": "Dodajte naziv za sandučić",
        "PICK_NAME": "Odaberite naziv za sandučić",
        "PICK_A_VALUE": "Odaberite vrijednost",
        "CREATE_INBOX": "Kreiraj sandučić"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Nastavi s Instagramom",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Povežite svoj Instagram profil",
        "HELP": "Da biste dodali svoj Instagram profil kao kanal, morate autentificirati svoj Instagram profil klikom na 'Nastavi s Instagramom' ",
        "ERROR_MESSAGE": "Došlo je do greške pri povezivanju s Instagramom, pokušajte ponovno",
        "ERROR_AUTH": "Došlo je do greške pri povezivanju s Instagramom, pokušajte ponovno",
        "NEW_INBOX_SUGGESTION": "Ovaj Instagram račun je prethodno bio povezan s drugim sandučićem i sada je migriran ovdje. Sve nove poruke pojavit će se ovdje. Stari sandučić više neće moći slati ili primati poruke za ovaj račun.",
        "DUPLICATE_INBOX_BANNER": "Ovaj Instagram račun je migriran u novi Instagram kanal sandučić. Više nećete moći slati/primati Instagram poruke iz ovog sandučića."
      },
      "TWITTER": {
        "HELP": "Da biste dodali svoj Twitter profil kao kanal, morate autentificirati svoj Twitter profil klikom na 'Prijava putem Twittera' ",
        "ERROR_MESSAGE": "Došlo je do pogreške pri povezivanju s Twitterom, pokušajte ponovno",
        "TWEETS": {
          "ENABLE": "Kreiraj razgovore iz tweetova u kojima ste spomenuti"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Kanal web stranice",
        "DESC": "Kreirajte kanal za svoju web stranicu i počnite pružati podršku korisnicima putem našeg widgeta.",
        "LOADING_MESSAGE": "Kreiranje kanala podrške za web stranicu",
        "CHANNEL_AVATAR": {
          "LABEL": "Avatar kanala"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "Unesite svoj Webhook URL",
          "ERROR": "Unesite valjani URL"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Domena web stranice",
          "PLACEHOLDER": "Unesite domenu web stranice (npr. acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Naslov dobrodošlice",
          "PLACEHOLDER": "Pozdrav!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Slogan dobrodošlice",
          "PLACEHOLDER": "Jednostavno nam se obratite. Pitajte nas bilo što ili podijelite svoje mišljenje."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Pozdravna poruka kanala",
          "PLACEHOLDER": "Acme Inc obično odgovara za nekoliko sati."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Omogući pozdravnu poruku kanala",
          "HELP_TEXT": "Automatically send a greeting message when a new conversation is created.",
          "ENABLED": "Omogućeno",
          "DISABLED": "Onemogućeno"
        },
        "REPLY_TIME": {
          "TITLE": "Postavite vrijeme odgovora",
          "IN_A_FEW_MINUTES": "Za nekoliko minuta",
          "IN_A_FEW_HOURS": "Za nekoliko sati",
          "IN_A_DAY": "U roku jednog dana",
          "HELP_TEXT": "Ovo vrijeme odgovora prikazat će se u live chat widgetu"
        },
        "WIDGET_COLOR": {
          "LABEL": "Boja widgeta",
          "PLACEHOLDER": "Ažurirajte boju widgeta"
        },
        "SUBMIT_BUTTON": "Kreiraj sandučić",
        "API": {
          "ERROR_MESSAGE": "Nismo uspjeli kreirati kanal web stranice, pokušajte ponovno"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/WhatsApp kanal",
        "DESC": "Integrirajte Twilio i počnite pružati podršku korisnicima putem SMS-a ili WhatsAppa.",
        "ACCOUNT_SID": {
          "LABEL": "Account SID",
          "PLACEHOLDER": "Unesite svoj Twilio Account SID",
          "ERROR": "Ovo polje je obavezno"
        },
        "API_KEY": {
          "USE_API_KEY": "Koristi autentifikaciju API ključem",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Unesite svoj API Key SID",
          "ERROR": "Ovo polje je obavezno"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Key Secret",
          "PLACEHOLDER": "Unesite svoj API Key Secret",
          "ERROR": "Ovo polje je obavezno"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Messaging Service SID",
          "PLACEHOLDER": "Unesite svoj Twilio Messaging Service SID",
          "ERROR": "Ovo polje je obavezno",
          "USE_MESSAGING_SERVICE": "Koristi Twilio Messaging Service"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Vrsta kanala",
          "ERROR": "Odaberite vrstu kanala"
        },
        "AUTH_TOKEN": {
          "LABEL": "Auth Token",
          "PLACEHOLDER": "Unesite svoj Twilio Auth Token",
          "ERROR": "Ovo polje je obavezno"
        },
        "CHANNEL_NAME": {
          "LABEL": "Naziv sandučića",
          "PLACEHOLDER": "Unesite naziv sandučića",
          "ERROR": "Ovo polje je obavezno"
        },
        "PHONE_NUMBER": {
          "LABEL": "Broj telefona",
          "PLACEHOLDER": "Unesite telefonski broj s kojeg će se slati poruke.",
          "ERROR": "Unesite ispravan telefonski broj koji počinje znakom `+` i ne sadrži razmake."
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "Morate konfigurirati callback URL za poruke u Twiliju s ovdje navedenim URL-om."
        },
        "SUBMIT_BUTTON": "Kreiraj Twilio kanal",
        "API": {
          "ERROR_MESSAGE": "Nismo uspjeli autentificirati Twilio vjerodajnice, pokušajte ponovno"
        }
      },
      "SMS": {
        "TITLE": "SMS kanal",
        "DESC": "Počnite pružati podršku korisnicima putem SMS-a.",
        "PROVIDERS": {
          "LABEL": "API pružatelj",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bandwidth",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "Nismo uspjeli spremiti SMS kanal"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "ID računa",
            "PLACEHOLDER": "Unesite ID svog Bandwidth računa",
            "ERROR": "Ovo polje je obavezno"
          },
          "API_KEY": {
            "LABEL": "API ključ",
            "PLACEHOLDER": "Unesite svoj Bandwidth API ključ",
            "ERROR": "Ovo polje je obavezno"
          },
          "API_SECRET": {
            "LABEL": "API tajna",
            "PLACEHOLDER": "Unesite svoju Bandwidth API tajnu",
            "ERROR": "Ovo polje je obavezno"
          },
          "APPLICATION_ID": {
            "LABEL": "ID aplikacije",
            "PLACEHOLDER": "Unesite ID svoje Bandwidth aplikacije",
            "ERROR": "Ovo polje je obavezno"
          },
          "INBOX_NAME": {
            "LABEL": "Naziv sandučića",
            "PLACEHOLDER": "Unesite naziv sandučića",
            "ERROR": "Ovo polje je obavezno"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefonski broj",
            "PLACEHOLDER": "Unesite telefonski broj s kojeg će se slati poruke.",
            "ERROR": "Unesite ispravan telefonski broj koji počinje znakom `+` i ne sadrži razmake."
          },
          "SUBMIT_BUTTON": "Kreiraj Bandwidth kanal",
          "API": {
            "ERROR_MESSAGE": "Nismo uspjeli autentificirati Bandwidth vjerodajnice, pokušajte ponovno"
          },
          "API_CALLBACK": {
            "TITLE": "Callback URL",
            "SUBTITLE": "Morate konfigurirati callback URL za poruke u Bandwidthu s ovdje navedenim URL-om."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Naziv sandučića",
            "PLACEHOLDER": "Unesite naziv sandučića",
            "ERROR": "Ovo polje je obavezno"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefonski broj",
            "PLACEHOLDER": "Unesite telefonski broj s kojeg će se slati poruke.",
            "ERROR": "Unesite ispravan telefonski broj koji počinje znakom `+`."
          },
          "SUBMIT_BUTTON": "Kreiraj SMS Brana kanal",
          "API": {
            "ERROR_MESSAGE": "Nismo uspjeli kreirati SMS Brana kanal"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Naziv sandučića",
            "PLACEHOLDER": "Unesite naziv sandučića",
            "ERROR": "Ovo polje je obavezno"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefonski broj",
            "PLACEHOLDER": "Unesite telefonski broj s kojeg će se slati poruke.",
            "ERROR": "Unesite ispravan telefonski broj koji počinje znakom `+`."
          },
          "SUBMIT_BUTTON": "Kreiraj DIDWW kanal",
          "API": {
            "ERROR_MESSAGE": "Nismo uspjeli kreirati DIDWW kanal"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "API pružatelj",
          "WHATSAPP_CLOUD": "WhatsApp Cloud"
        },
        "API_CALLBACK": {
          "SUBTITLE": "Morate konfigurirati webhook URL i token za provjeru na Facebook Developer portalu s vrijednostima prikazanima u nastavku.",
          "WEBHOOK_URL": "Webhook URL",
          "WEBHOOK_VERIFICATION_TOKEN": "Token za provjeru webhooka"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Brzo postavljanje s Metom",
          "DESC": "Bit ćete preusmjereni na Metu radi prijave na svoj WhatsApp Business račun. Administratorski pristup olakšat će i ubrzati postavljanje.",
          "BENEFITS": {
            "EASY_SETUP": "Nije potrebna ručna konfiguracija",
            "SECURE_AUTH": "Sigurna autentifikacija temeljena na OAuthu",
            "AUTO_CONFIG": "Automatska konfiguracija webhooka i telefonskog broja"
          },
          "SUBMIT_BUTTON": "Poveži s WhatsApp Businessom",
          "AUTH_PROCESSING": "Autentifikacija s Metom",
          "WAITING_FOR_BUSINESS_INFO": "Dovršite poslovno postavljanje u prozoru Mete...",
          "PROCESSING": "Postavljanje vašeg WhatsApp Business računa",
          "CANCELLED": "WhatsApp registracija je otkazana",
          "WAITING_FOR_AUTH": "Čekanje autentifikacije...",
          "INVALID_BUSINESS_DATA": "Od Facebooka su primljeni nevažeći poslovni podaci. Pokušajte ponovno.",
          "SIGNUP_ERROR": "Došlo je do pogreške pri registraciji",
          "SDK_LOAD_ERROR": "Facebook SDK nije moguće učitati. Pokušajte ponovno.",
          "AUTH_NOT_COMPLETED": "Autentifikacija nije dovršena. Ponovno pokrenite postupak.",
          "SUCCESS_FALLBACK": "WhatsApp Business račun je uspješno konfiguriran",
          "RECONNECTED": "WhatsApp kanal uspješno je ponovno povezan"
        },
        "API": {
          "ERROR_MESSAGE": "Nismo uspjeli spremiti WhatsApp kanal"
        }
      },
      "API_CHANNEL": {
        "TITLE": "API kanal",
        "DESC": "Integrirajte API kanal i počnite pružati podršku korisnicima.",
        "CHANNEL_NAME": {
          "LABEL": "Naziv kanala",
          "PLACEHOLDER": "Unesite naziv kanala",
          "ERROR": "Ovo polje je obavezno"
        },
        "WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "SUBTITLE": "Konfigurirajte URL na koji želite primati callbackove o događajima.",
          "PLACEHOLDER": "Webhook URL"
        },
        "SUBMIT_BUTTON": "Kreiraj API kanal",
        "API": {
          "ERROR_MESSAGE": "Nismo uspjeli spremiti API kanal"
        }
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Salesforce kanal",
        "DESC": "Integrirajte sa Salesforce kanalom i započnite pružati podršku svojim korisnicima.",
        "CHANNEL_NAME": {
          "LABEL": "Naziv kanala",
          "PLACEHOLDER": "Unesite naziv kanala",
          "ERROR": "Ovo polje je obavezno"
        },
        "API_BASE_URL": {
          "LABEL": "Salesforce API URL",
          "SUBTITLE": "Konfigurirajte osnovni URL za vašu Salesforce instancu.",
          "PLACEHOLDER": "URL Salesforce API-ja",
          "ERROR": "Ovo polje je obavezno"
        },
        "KEY_ID": {
          "LABEL": "ID ključa",
          "SUBTITLE": "Key ID za vaš Salesforce kanal.",
          "PLACEHOLDER": "ID ključa",
          "ERROR": "Ovo polje je obavezno"
        },
        "SECRET": {
          "LABEL": "Tajna",
          "SUBTITLE": "Tajna za vaš Salesforce kanal.",
          "PLACEHOLDER": "*****",
          "ERROR": "Ovo polje je obavezno"
        },
        "SUBMIT_BUTTON": "Kreiraj Salesforce kanal",
        "API": {
          "ERROR_MESSAGE": "Nismo uspjeli spremiti Salesforce kanal"
        },
        "API_CALLBACK": {
          "TITLE": "Webhook URL",
          "SUBTITLE": "Morate konfigurirati webhook URL u Salesforceu s ovdje navedenim URL-om."
        },
        "BEARER_TOKEN": {
          "TITLE": "Bearer token",
          "SUBTITLE": "Koristite ovaj bearer token za autentifikaciju pri konfiguraciji webhooka u Salesforceu."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "Nadjačaj pošiljatelja e-maila",
          "SUBTITLE": "Ako je postavljeno, ova e-mail adresa koristit će se kao pošiljatelj za sve odlazne e-mailove umjesto izvorne e-mail adrese razgovora.",
          "PLACEHOLDER": "npr. support{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Allegro kanal",
        "DESC": "Povežite Allegro prodajni račun i iz kontaktnog centra odgovarajte na poruke iz njegova centra poruka.",
        "CHANNEL_NAME": {
          "LABEL": "Naziv sandučića",
          "SUBTITLE": "Naziv koji agenti vide za ovaj sandučić.",
          "PLACEHOLDER": "Unesite naziv sandučića",
          "ERROR": "Ovo polje je obavezno"
        },
        "SUBMIT_BUTTON": "Prijavi se putem Allegra",
        "API": {
          "ERROR_MESSAGE": "Došlo je do pogreške pri povezivanju s Allegrom, pokušajte ponovno"
        },
        "SELLER_LOGIN": {
          "TITLE": "Prijava na Allegro",
          "SUBTITLE": "Prodajni račun za koji ovaj sandučić čita poruke i odgovara na njih."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Kaufland kanal",
        "DESC": "Odgovarajte na poruke u tiketima koje vam kupci šalju na tržištu Kaufland.",
        "CHANNEL_NAME": {
          "LABEL": "Naziv kanala",
          "PLACEHOLDER": "Unesite naziv kanala",
          "ERROR": "Ovo polje je obavezno"
        },
        "CLIENT_KEY": {
          "LABEL": "Klijentski ključ",
          "SUBTITLE": "Client Key od 32 znaka sa stranice API postavki vašeg Kaufland prodajnog računa.",
          "PLACEHOLDER": "ključ od 32 znaka",
          "ERROR": "Unesite Client Key od 32 znaka"
        },
        "SECRET_KEY": {
          "LABEL": "Tajni ključ",
          "SUBTITLE": "Secret Key od 64 znaka koji pripada Client Keyu. Kaufland ga prikazuje jednom i nikada se ne vraća na ovu stranicu.",
          "PLACEHOLDER": "ključ od 64 znaka",
          "ERROR": "Unesite Secret Key od 64 znaka"
        },
        "SUBMIT_BUTTON": "Kreiraj Kaufland kanal",
        "API": {
          "ERROR_MESSAGE": "Nismo uspjeli spremiti Kaufland kanal"
        },
        "DISCONNECTED": {
          "TITLE": "Nije povezano",
          "MESSAGE": "Kaufland je odbio ove API ključeve. Ponovno unesite Client Key i Secret Key da biste ponovno povezali ovaj sandučić."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "E-mail kanal",
        "DESC": "Integrirajte svoj e-mail sandučić.",
        "CHANNEL_NAME": {
          "LABEL": "Naziv kanala",
          "PLACEHOLDER": "Unesite naziv kanala",
          "ERROR": "Ovo polje je obavezno"
        },
        "EMAIL": {
          "LABEL": "Email",
          "SUBTITLE": "Navedite e-mail adresu na koju korisnici šalju zahtjeve za podršku.",
          "PLACEHOLDER": "Email"
        },
        "SUBMIT_BUTTON": "Kreiraj e-mail kanal",
        "API": {
          "ERROR_MESSAGE": "Nismo uspjeli spremiti e-mail kanal"
        },
        "FINISH_MESSAGE": "Počnite prosljeđivati svoje e-mailove na sljedeću e-mail adresu."
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE kanal",
        "DESC": "Integrirajte LINE kanal i počnite pružati podršku korisnicima.",
        "CHANNEL_NAME": {
          "LABEL": "Naziv kanala",
          "PLACEHOLDER": "Unesite naziv kanala",
          "ERROR": "Ovo polje je obavezno"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "LINE Channel ID",
          "PLACEHOLDER": "LINE Channel ID"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "LINE Channel Secret",
          "PLACEHOLDER": "LINE Channel Secret"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "LINE Channel Token",
          "PLACEHOLDER": "LINE Channel Token"
        },
        "SUBMIT_BUTTON": "Kreiraj LINE kanal",
        "API": {
          "ERROR_MESSAGE": "Nismo uspjeli spremiti LINE kanal"
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "Morate konfigurirati webhook URL u LINE aplikaciji s ovdje navedenim URL-om."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegram kanal",
        "DESC": "Integrirajte Telegram kanal i počnite pružati podršku korisnicima.",
        "BOT_TOKEN": {
          "LABEL": "Token bota",
          "SUBTITLE": "Konfigurirajte token bota koji ste dobili od Telegram BotFathera.",
          "PLACEHOLDER": "Token bota"
        },
        "SUBMIT_BUTTON": "Kreiraj Telegram kanal",
        "API": {
          "ERROR_MESSAGE": "Nismo uspjeli spremiti Telegram kanal"
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Telefonski pozivi",
        "DESC": "Postavite koji će se telefonski pozivi prikazivati pod ovim sandučićem.",
        "NAME": {
          "LABEL": "Naziv sandučića",
          "SUBTITLE": "Odaberite lako prepoznatljivo ime."
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefonski broj",
          "SUBTITLE": "Unesite telefonske brojeve koji pripadaju ovom sandučiću, više brojeva možete dodati kasnije.",
          "PLACEHOLDER": "+385123908635"
        },
        "SUBMIT_BUTTON": "Kreiraj sandučić telefonskih poziva",
        "API": {
          "ERROR_MESSAGE": "Nismo uspjeli kreirati sandučić"
        }
      },
      "AUTH": {
        "TITLE": "Odaberite kanal",
        "DESC": "Chat podržava live-chat widgete, Facebook Messenger, WhatsApp, e-poštu itd. kao kanale. Ako želite izraditi prilagođeni kanal, možete ga kreirati pomoću API kanala. Za početak odaberite jedan od kanala u nastavku."
      },
      "AGENTS": {
        "TITLE": "Agenti",
        "DESC": "Ovdje možete dodati agente koji će upravljati novokreiranim sandučićem. Samo odabrani agenti imat će pristup sandučiću. Agenti koji nisu dio ovog sandučića neće moći vidjeti niti odgovarati na poruke u njemu nakon prijave. <br> <b>PS:</b> Ako kao administrator trebate pristup svim sandučićima, dodajte sebe kao agenta u sve sandučiće koje kreirate.",
        "VALIDATION_ERROR": "Dodajte barem jednog agenta u novi sandučić",
        "PICK_AGENTS": "Odaberite agente za sandučić"
      },
      "DETAILS": {
        "TITLE": "Detalji sandučića",
        "DESC": "Na padajućem popisu u nastavku odaberite Facebook stranicu koju želite povezati s chatom. Pretincu možete dati i prilagođeni naziv radi lakšeg prepoznavanja."
      },
      "FINISH": {
        "TITLE": "Uspjelo je!",
        "DESC": "Uspješno ste dovršili integraciju svoje Facebook stranice s chatom. Kada vam klijent sljedeći put pošalje poruku na stranicu, razgovor će se automatski pojaviti u vašem pretincu.<br>Pružamo vam i skriptu widgeta koju možete jednostavno dodati na svoju web stranicu. Kada je widget aktivan na vašoj web stranici, klijenti vam mogu slati poruke izravno s nje bez ikakvog vanjskog alata, a razgovor će se pojaviti upravo ovdje, u chatu.<br>Super, zar ne? Barem se trudimo :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Odaberite pružatelja e-mail usluge",
        "DESCRIPTION": "Odaberite pružatelja e-mail usluge s popisa u nastavku. Ako svog pružatelja ne vidite na popisu, odaberite opciju drugog pružatelja i unesite IMAP i SMTP vjerodajnice."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft e-mail",
        "DESCRIPTION": "Za početak kliknite gumb Prijava putem Microsofta. Bit ćete preusmjereni na stranicu za prijavu e-mailom. Nakon što prihvatite tražena dopuštenja, bit ćete vraćeni na korak kreiranja sandučića.",
        "EMAIL_PLACEHOLDER": "Unesite e-mail adresu",
        "SIGN_IN": "Prijava putem Microsofta",
        "ERROR_MESSAGE": "Došlo je do pogreške pri povezivanju s Microsoftom, pokušajte ponovno"
      },
      "GOOGLE": {
        "TITLE": "Google e-mail",
        "DESCRIPTION": "Za početak kliknite gumb Prijava putem Googlea. Bit ćete preusmjereni na stranicu za prijavu e-mailom. Nakon što prihvatite tražena dopuštenja, bit ćete vraćeni na korak kreiranja sandučića.",
        "SIGN_IN": "Prijava putem Googlea",
        "EMAIL_PLACEHOLDER": "Unesite e-mail adresu",
        "ERROR_MESSAGE": "Došlo je do pogreške pri povezivanju s Googleom, pokušajte ponovno"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Autentifikacija putem Facebooka...",
      "ERROR_FB_LOADING": "Pogreška pri učitavanju Facebook SDK-a. Onemogućite blokatore oglasa i pokušajte ponovno u drugom pregledniku.",
      "ERROR_FB_AUTH": "Nešto je pošlo po zlu, osvježite stranicu...",
      "ERROR_FB_UNAUTHORIZED": "Niste ovlašteni za ovu radnju. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Provjerite imate li pristup Facebook stranici s potpunom kontrolom. Više o Facebook ulogama možete pročitati <a href=\" https://www.facebook.com/help/187316341316631\">ovdje</a>.",
      "ERROR_CHANNEL_CREATION": "Nismo uspjeli kreirati sandučić. Pokušajte ponovno.",
      "CREATING_CHANNEL": "Kreiranje sandučića...",
      "TITLE": "Konfigurirajte detalje sandučića",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Dodaj agente",
      "ADD_AGENTS": "Dodavanje agenata u sandučić..."
    },
    "FINISH": {
      "TITLE": "Vaš sandučić je spreman!",
      "MESSAGE": "Sada možete komunicirati s korisnicima putem novog kanala. Uspješnu podršku!",
      "BUTTON_TEXT": "Odvedi me tamo",
      "MORE_SETTINGS": "Više postavki",
      "WEBSITE_SUCCESS": "Uspješno ste kreirali kanal web stranice. Kopirajte kod prikazan u nastavku i zalijepite ga na svoju web stranicu. Kada korisnik sljedeći put upotrijebi live chat, razgovor će se automatski pojaviti u vašem sandučiću."
    },
    "REAUTH": "Ponovno autoriziraj",
    "VIEW": "Prikaži",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Postavke sandučića su uspješno ažurirane",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Automatska dodjela je uspješno ažurirana",
        "ERROR_MESSAGE": "Nismo uspjeli ažurirati postavke sandučića. Pokušajte ponovno kasnije."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Omogućeno",
        "DISABLED": "Onemogućeno"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Omogućeno",
        "DISABLED": "Onemogućeno"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Omogućeno",
        "DISABLED": "Onemogućeno"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Ime pošiljatelja",
        "SUB_TEXT": "Odaberite ime koje korisnik vidi kada prima e-mailove od vaših agenata.",
        "FOR_EG": "Na primjer:",
        "FRIENDLY": {
          "TITLE": "Prijateljski",
          "FROM": "od",
          "SUBTITLE": "Dodajte ime agenta koji je poslao odgovor u ime pošiljatelja kako bi bilo prijateljskije."
        },
        "PROFESSIONAL": {
          "TITLE": "Profesionalno",
          "SUBTITLE": "Koristite samo konfigurirani naziv tvrtke kao ime pošiljatelja u zaglavlju e-maila."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Konfigurirajte naziv tvrtke",
          "PLACEHOLDER": "Unesite naziv tvrtke",
          "SAVE_BUTTON_TEXT": "Spremi"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Omogućeno",
        "DISABLED": "Onemogućeno"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Omogućeno",
        "DISABLED": "Onemogućeno"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Ništa"
      },
      "SHOW_WELCOME_SCREEN": {
        "ENABLED": "Omogućeno",
        "DISABLED": "Onemogućeno"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Omogućeno",
        "DISABLED": "Onemogućeno"
      },
      "ENABLE_HMAC": {
        "LABEL": "Omogući"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Omogućeno",
        "DISABLED": "Onemogućeno"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Omogućeno",
        "DISABLED": "Onemogućeno"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Omogući sinkronizaciju dolaznih e-mailova"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Omogući prilagođenu e-mail domenu (plaćena usluga)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Omogući obradu Facebook komentara"
      },
      "SIGNATURE": {
        "TITLE": "HTML potpis",
        "SUB_TEXT": "Ovaj potpis bit će dodan u podnožje svake poruke poslane iz ovog sandučića.",
        "HTML_CONTENT": "HTML kod",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} bit će zamijenjeno imenom agenta.\n{'{{'}email{'}}'} bit će zamijenjeno e-mail adresom agenta koji je poslao e-mail.\n{'{{'}position{'}}'} bit će zamijenjeno pozicijom agenta.\n{'{{'}custom_line{'}}'} bit će zamijenjeno prilagođenim retkom agenta.\n{'{{'}email_signature_picture{'}}'} bit će zamijenjeno URL-om slike e-mail potpisa agenta (ne oznakom slike) — upotrijebite ga kao izvor slike (atribut src img oznake).",
        "PREVIEW": "Pregled"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Potpisi po državi",
        "SUB_TEXT": "Odgovor dobiva potpis države kupca.",
        "HELP": "Odgovor se potpisuje prema državi razgovora: trgovini na Kauflandu, tržnici Allegro narudžbe ili, inače, jeziku na kojem kupac piše. Kada je država nepoznata ili za nju ovdje nema potpisa, koristi se HTML potpis iznad. Tržnice zabranjuju poveznice na vašu web-stranicu i kontaktne podatke, stoga ostavite samo pozdrav i {'{{'}name{'}}'}.",
        "EMPTY": "Još nemate potpisa po državi, stoga odgovori koriste HTML potpis iznad.",
        "COUNTRY": "Odaberite državu",
        "ADD": "Dodaj potpis za državu",
        "REMOVE": "Ukloni"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Prefiks biranja telefonskog broja",
        "PLACEHOLDER": "Unesite prefiks za ispravno usmjeravanje poziva (npr. *99)",
        "HELP_TEXT": "Ovaj prefiks automatski će se dodati ispred telefonskih brojeva kontakta pri biranju iz ovog sandučića."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Tekst gumba „riješit ćemo kasnije“",
        "PLACEHOLDER": "npr. Ovu temu ćemo riješiti putem e-pošte. Sada bih želio pitati o nečem drugom.",
        "HELP_TEXT": "Natpis gumba u widgetu kojim posjetitelj napušta trenutačnu temu i pita o nečem drugom. Ako polje ostavite prazno, koristit će se zadani tekst na jeziku posjetitelja."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Automatski odgodi propuštene pozive za X minuta",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Automatski odgodi propuštene pozive za navedeni broj minuta. Ostavite prazno ili 0 za onemogućavanje."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Riješi propušteni poziv nakon X neuspjelih povratnih poziva",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Kada se propušteni poziv nazove natrag X puta, a klijent se ne javi, automatski se rješava i dodaje se privatna bilješka. Ostavite prazno ili 0 za onemogućavanje."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Prijedlozi pitanja",
        "SUB_TEXT": "Konfigurirajte unaprijed definirana pitanja koja korisnici mogu koristiti za interakciju s vašim agentima.",
        "QUESTIONS_LABEL": "Pitanja",
        "ADD_QUESTION": "Dodaj pitanje",
        "QUESTION": "Pitanje",
        "REMOVE": "Ukloni",
        "QUESTION_TEXT": "Tekst prikazan u oblačiću.",
        "QUESTION_TEXT_PLACEHOLDER": "Obavezno",
        "QUESTION_PAYLOAD": "Tekst poslan pri kliku.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Opcionalno",
        "SAVE": "Spremi",
        "NO_BOT_MESSAGE": "Za generiranje dodatnih AI prijedloga, povežite bota.",
        "BOT_CONNECTED_MESSAGE": "AI prijedloge pitanja od bota možete aktivirati u njegovim",
        "BOT_SETTINGS_LINK": "postavkama"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Alternativne e-adrese",
        "SUB_TEXT": "Dodatne adrese koje bi ovaj pretinac trebao tretirati kao vlastite pri primanju proslijeđene pošte.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Dodaj",
        "REMOVE": "Ukloni",
        "EMPTY": "Nema konfiguriranih alternativnih e-adresa.",
        "HELP_TEXT": "Kada e-pošta stigne s jednom od ovih adresa kao primateljem, odgovori će se slati s iste adrese kao pošiljatelja. Provjerite dopušta li vaš odlazni SMTP poslužitelj slanje s tih adresa.",
        "SIGNATURE_LABEL": "Potpis",
        "PRIMARY_SIGNATURE": "Primarni (zadano)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Dodatni potpisi",
        "SUB_TEXT": "Ovdje definirajte dodatne potpise, a zatim ih dodijelite alternativnim e-adresama u nastavku.",
        "OPTION": "Potpis {number}",
        "ADD": "Dodaj potpis",
        "REMOVE": "Ukloni",
        "HELP_TEXT": "Kada se odgovor šalje s alternativne e-adrese, koristi se njoj dodijeljeni potpis umjesto potpisa pretinca. Alternativne e-adrese ostavljene na „Primarni (zadano)” koriste potpis pretinca."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Izbriši",
      "AVATAR_DELETE_BUTTON_TEXT": "Izbriši avatar",
      "DELETE_REQUESTED_TOOLTIP": "Ovaj sandučić je označen za brisanje",
      "RESTORE_BUTTON_TEXT": "Vrati",
      "CONFIRM": {
        "TITLE": "Potvrdi brisanje",
        "MESSAGE": "Jeste li sigurni da želite izbrisati ",
        "PLACE_HOLDER": "Upišite {inboxName} za potvrdu",
        "YES": "Da, izbriši",
        "NO": "Ne, zadrži"
      },
      "API": {
        "SUCCESS_MESSAGE": "Sandučić je uspješno izbrisan",
        "MARKED_FOR_DELETION_MESSAGE": "Sandučić označen za brisanje",
        "RESTORE_SUCCESS_MESSAGE": "Sandučić uspješno vraćen",
        "ERROR_MESSAGE": "Nije moguće izbrisati sandučić. Pokušajte ponovno kasnije.",
        "RESTORE_ERROR_MESSAGE": "Nije moguće vratiti sandučić. Pokušajte kasnije.",
        "AVATAR_SUCCESS_MESSAGE": "Avatar sandučića je uspješno izbrisan",
        "AVATAR_ERROR_MESSAGE": "Nije moguće izbrisati avatar sandučića. Pokušajte ponovno kasnije."
      }
    },
    "TABS": {
      "SETTINGS": "Postavke",
      "COLLABORATORS": "Suradnici",
      "AUTOMATIC_PRIORITY": "Automatski prioritet",
      "AUTOMATIC_LABELING": "Automatsko označavanje",
      "CONFIGURATION": "Konfiguracija",
      "CAMPAIGN": "Kampanje",
      "PRE_CHAT_FORM": "Obrazac prije chata",
      "BUSINESS_HOURS": "Radno vrijeme",
      "WIDGET_BUILDER": "Izrada widgeta",
      "BOT_CONFIGURATION": "Konfiguracija bota",
      "SLA": "SLA"
    },
    "SETTINGS": "Postavke",
    "FEATURES": {
      "LABEL": "Značajke",
      "DISPLAY_FILE_PICKER": "Prikaži odabir datoteka u widgetu",
      "DISPLAY_EMOJI_PICKER": "Prikaži odabir emojija u widgetu",
      "ALLOW_END_CONVERSATION": "Dopusti korisnicima završetak razgovora iz widgeta",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Prikaži gumb 'Pokreni novi razgovor' u zaglavlju widgeta",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Sakrij polje za unos kada je prikazan gumb za novi razgovor",
      "SHOW_HANDOFF_BUTTON": "Prikaži gumb 'Prebaci operateru' u zaglavlju widgeta",
      "USE_INBOX_AVATAR_FOR_BOT": "Koristi naziv i avatar sandučića za bota",
      "ALLOW_OFFLINE_REPLY": "Dopusti agentima slanje poruka kada je kontakt offline i e-mail kontinuitet nije dostupan",
      "AUTO_CLOSE_OLD": "Označi sve prošle pozive s istog broja kao riješene nakon što je jedan riješen",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Automatski dodijeli propuštene pozive pri odlaznom pozivu"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Messenger Script",
      "MESSENGER_SUB_HEAD": "Postavite ovaj gumb unutar oznake body",
      "INBOX_AGENTS": "Agenti",
      "INBOX_TEAMS": "Timovi",
      "INBOX_COOPERATORS": "Suradnici",
      "SELECT_PLACEHOLDER": "Odaberi",
      "AGENTS_OR_TEAMS_INFO": "Možete dodijeliti agente ili timove - ne oboje istovremeno.",
      "AGENT_ASSIGNMENT": "Dodjela razgovora",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Ažurirajte postavke dodjele razgovora",
      "UPDATE": "Ažuriraj",
      "ENABLE_EMAIL_COLLECT_BOX": "Omogući okvir za prikupljanje e-maila",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Omogućite ili onemogućite okvir za prikupljanje e-maila u novom razgovoru",
      "AUTO_ASSIGNMENT": "Omogući automatsku dodjelu",
      "ENABLE_CSAT": "Omogući CSAT",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "Omogući CSAT na svakoj poruci",
      "SENDER_NAME_SECTION": "Omogući ime agenta u e-mailu",
      "ENABLE_CSAT_SUB_TEXT": "Omogućite/onemogućite CSAT anketu (zadovoljstvo korisnika) nakon rješavanja razgovora",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Omogući/onemogući opciju CSAT ankete za svaku poruku koju šalju agenti",
      "SENDER_NAME_SECTION_TEXT": "Omogućite/onemogućite prikaz imena agenta u e-mailu; ako je onemogućeno, prikazuje se naziv tvrtke",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Omogući nastavak razgovora putem e-maila",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Razgovori će se nastaviti putem e-maila ako je e-mail adresa kontakta dostupna.",
      "RESPOND_FROM_EMAIL": "Odgovaraj s e-maila",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "E-mailovi korisniku — i odgovori i transkripti razgovora — šalju se putem SMTP postavki odabranog e-mail sandučića, s odabrane adrese (vlastite adrese sandučića ili jednog od njegovih aliasa), a odgovori korisnika vraćaju se putem njegove IMAP adrese.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Transkripti razgovora šalju se putem SMTP postavki odabranog e-mail sandučića, s odabrane adrese (vlastite adrese sandučića ili jednog od njegovih aliasa), a odgovori se vraćaju putem njegove IMAP adrese.",
      "SHOW_WELCOME_SCREEN": "Prikaži zaslon dobrodošlice",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Prikaži zaslon dobrodošlice kada se otvori widget. Ako je onemogućeno, widget će ići izravno na prikaz razgovora.",
      "AUTO_CLOSE_PENDING": "Automatski riješi AI chatove nakon (sati)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "Automatski riješi AI chatove nakon X sati neaktivnosti.",
      "LOCK_TO_SINGLE_CONVERSATION": "Ograniči na jedan razgovor",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Omogućite ili onemogućite više razgovora za isti kontakt u ovom sandučiću",
      "INBOX_UPDATE_TITLE": "Postavke sandučića",
      "INBOX_UPDATE_SUB_TEXT": "Ažurirajte postavke sandučića",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Omogućite ili onemogućite automatsku dodjelu novih razgovora agentima dodanima u ovaj sandučić.",
      "HMAC_VERIFICATION": "Provjera identiteta korisnika",
      "HMAC_DESCRIPTION": "In order to validate the user's identity, you can pass an `identifier_hash` for each user. You can generate a HMAC sha256 hash using the `identifier` with the key shown here.",
      "HMAC_ROTATE": {
        "BUTTON": "Rotiraj ključ",
        "TITLE": "Želite li rotirati tajni ključ?",
        "WARNING": "Trenutni ključ prestaje vrijediti u trenutku rotacije.",
        "WARNING_DETAIL": "Nema razdoblja preklapanja i ključ se ne može vratiti.",
        "IMPACT": "Vaši poslužitelji moraju potpisivati korisnike novim ključem. Svatko tko je i dalje potpisan starim ključem neće proći provjeru. Ako je provjera identiteta obavezna, ti korisnici ne mogu započeti razgovor.",
        "CONFIRM": "Rotiraj ključ",
        "CANCEL": "Odustani",
        "SUCCESS": "Tajni ključ uspješno rotiran",
        "ERROR": "Nije moguće rotirati tajni ključ, pokušajte ponovno"
      },
      "HMAC_LINK_TO_DOCS": "Ovdje možete pročitati više.",
      "HMAC_MANDATORY_VERIFICATION": "Zahtijevaj provjeru identiteta korisnika",
      "HMAC_MANDATORY_DESCRIPTION": "If enabled, requests missing the `identifier_hash` will be rejected.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Prisili novi razgovor pri svakom učitavanju widgeta",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Ako je omogućeno, otvaranje widgeta u novoj kartici ili prozoru pokreće novi razgovor.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Zaboravi kontakt kada se pokrene novi razgovor",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Ako je onemogućeno, novi razgovor pokrenut putem widgeta zadržava prethodni kontakt.",
      "INBOX_IDENTIFIER": "Identifikator sandučića",
      "INBOX_IDENTIFIER_SUB_TEXT": "Koristite ovdje prikazani token `inbox_identifier` za autentifikaciju svojih API klijenata.",
      "FORWARD_EMAIL_TITLE": "Proslijedi na e-mail",
      "FORWARD_EMAIL_SUB_TEXT": "Počnite prosljeđivati svoje e-mailove na sljedeću e-mail adresu.",
      "EMAIL_FETCHING_ENABLED_TITLE": "Sinkronizacija e-maila",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Omogući automatsku sinkronizaciju i preuzimanje dolaznih e-mailova iz ovog sandučića",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Prilagođena e-mail domena",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Omogući korištenje prilagođene e-mail domene za odlazne e-mailove",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "Više možete pročitati ovdje.",
      "FACEBOOK_COMMENTS_TITLE": "Facebook komentari",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Dopusti poruke nakon rješavanja razgovora",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Dopustite krajnjim korisnicima slanje poruka i nakon što je razgovor riješen.",
      "WIDGET_STATUS_LABEL": "Status widgeta",
      "WIDGET_STATUS_ENABLED": "Omogućeno",
      "WIDGET_STATUS_BUSINESS_HOURS": "Omogućeno tijekom radnog vremena",
      "WIDGET_STATUS_DISABLED": "Onemogućeno",
      "WIDGET_STATUS_HELP_TEXT": "Kontrolirajte kada se widget prikazuje posjetiteljima na vašoj web stranici",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Ažuriraj postavke obrasca prije chata",
      "EXPLICIT_CSAT_LOCALE": "Jezik CSAT ankete i e-maila",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Odaberite jezik za sve e-mailove korisnicima, uključujući CSAT ankete, transkripte razgovora i obavijesti e-mailom",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Naslijedi od računa",
      "WHATSAPP_CONNECTION": {
        "TITLE": "WhatsApp veza",
        "SUBTITLE": "Kako je ovaj pretinac povezan s WhatsAppom.",
        "PROVIDER": "Pružatelj usluge",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Povezano putem ugrađene Meta registracije",
        "STATUS": "Status",
        "CONNECTED": "Povezano",
        "RECONNECT_HINT": "Kliknite Ponovno poveži u obavijesti iznad.",
        "PHONE_NUMBER": "Broj telefona",
        "BUSINESS_ACCOUNT": "ID WhatsApp Business računa",
        "OPEN_MANAGER": "Otvori u WhatsApp Manageru",
        "PHONE_NUMBER_ID": "ID broja telefona",
        "TEMPLATES": "Predlošci poruka",
        "TEMPLATES_COUNT": "Odobreno {approved} od {total}",
        "TEMPLATES_SYNCED": "Posljednja sinkronizacija: {date}",
        "TEMPLATES_NOT_SYNCED": "Još nije sinkronizirano",
        "MANAGE_TEMPLATES": "Upravljaj predlošcima"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Centar za pomoć",
      "PLACEHOLDER": "Odaberi centar za pomoć",
      "SELECT_PLACEHOLDER": "Odaberi centar za pomoć",
      "REMOVE": "Makni Centar za Pomoć",
      "SUB_TEXT": "Pridruži Centar za Pomoć inbox-u"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Ograničenje automatske dodjele",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Unesite vrijednost veću od 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Ograničite najveći broj razgovora iz ovog sandučića koji se mogu automatski dodijeliti agentu"
    },
    "SLA": {
      "TITLE": "SLA pravila",
      "SUB_TEXT": "Konfigurirajte SLA vremena odgovora i rješavanja za svaku razinu prioriteta razgovora.",
      "LOADING": "Učitavanje SLA pravila...",
      "FIELDS": {
        "ACTIVE": "Aktivno",
        "TICKET_PRIORITY": "Prioritet tiketa",
        "FIRST_RESPONSE_TIME": "Vrijeme prvog odgovora",
        "EVERY_RESPONSE_TIME": "Vrijeme svakog odgovora",
        "RESOLUTION_TIME": "Vrijeme rješavanja",
        "PLACEHOLDER": "npr. 1h 30m"
      },
      "API": {
        "SUCCESS_MESSAGE": "SLA pravila uspješno ažurirana.",
        "ERROR_MESSAGE": "Nije moguće ažurirati SLA pravila. Pokušajte ponovno."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Automatski prioritet",
      "SUB_TEXT": "Konfigurirajte automatsku dodjelu prioriteta na temelju sadržaja razgovora.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Obavijest o naplati",
        "MESSAGE": "Svaka evaluacija prioriteta podliježe naplati. Pregledajte detalje plana za informacije o cijenama."
      },
      "MODE": {
        "OFF": "Isključeno",
        "ALL_MESSAGES": "Uključeno za sve dolazne poruke",
        "FIRST_MESSAGE": "Uključeno samo za prvu dolaznu poruku"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Konfiguracija razina prioriteta",
        "SUB_TEXT": "Konfigurirajte koje razine prioriteta trebaju biti omogućene i njihove opise. Navedite jasne kriterije za AI da odredi kada treba dodijeliti ovaj prioritet."
      },
      "DESCRIPTION_LABEL": "Opis",
      "DESCRIPTION_PLACEHOLDER": "Opišite razgovore koji trebaju biti označeni prioritetom {priority}",
      "SET_AS_DEFAULT": "Postavi kao zadani prioritet",
      "MULTIPLE_DEFAULTS_WARNING": "Samo jedna razina prioriteta treba biti postavljena kao zadana. Poništite odabir ostalih zadanih."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Automatsko označavanje",
      "SUB_TEXT": "Konfigurirajte automatsku dodjelu oznaka na temelju sadržaja razgovora.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Obavijest o naplati",
        "MESSAGE": "Svaka evaluacija označavanja podliježe naplati. Pregledajte detalje plana za informacije o cijenama."
      },
      "MODE": {
        "OFF": "Isključeno",
        "CONVERSATION_OPEN": "Pri otvaranju razgovora",
        "CONVERSATION_CLOSE": "Pri zatvaranju razgovora",
        "ALL_MESSAGES": "Pri svakoj poruci - bez obzira na stanje",
        "FIRST_MESSAGE": "Pri prvoj poruci - bez obzira na stanje"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Konfiguracija oznaka",
        "SUB_TEXT": "Konfigurirajte koje oznake trebaju biti dostupne za automatsku dodjelu i njihove opise. Navedite jasne kriterije za AI da odredi kada treba primijeniti ovu oznaku."
      },
      "DESCRIPTION_LABEL": "Opis",
      "DESCRIPTION_PLACEHOLDER": "Opišite razgovore koji trebaju biti označeni kao {label}. Ako ovo ostavite prazno, koristit će se opis oznake.",
      "NO_LABELS_MESSAGE": "Nije pronađena nijedna oznaka. Prvo kreirajte oznake za omogućavanje automatskog označavanja.",
      "CREATE_LABELS_LINK": "Kreiraj oznake"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Ponovno autoriziraj",
      "SUBTITLE": "Vaša Facebook veza je istekla, ponovno povežite svoju Facebook stranicu za nastavak usluga",
      "MESSAGE_SUCCESS": "Ponovno povezivanje je uspjelo",
      "MESSAGE_ERROR": "Došlo je do pogreške, pokušajte ponovno"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Obrasci prije chata omogućuju vam prikupljanje podataka o korisniku prije nego što započne razgovor s vama.",
      "SET_FIELDS": "Polja obrasca prije chata",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Polja",
        "LABEL": "Oznaka",
        "PLACE_HOLDER": "Tekst rezerviranog mjesta",
        "KEY": "Ključ",
        "TYPE": "Vrsta",
        "REQUIRED": "Obavezno"
      },
      "ENABLE": {
        "LABEL": "Omogući obrazac prije chata",
        "OPTIONS": {
          "ENABLED": "Da",
          "DISABLED": "Ne"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Poruka prije chata",
        "PLACEHOLDER": "Ova poruka bit će vidljiva korisnicima zajedno s obrascem"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Posjetitelji moraju navesti ime i e-mail adresu prije početka chata"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Postavite svoju dostupnost",
      "SUBTITLE": "Postavite svoju dostupnost u live chat widgetu",
      "WEEKLY_TITLE": "Postavite tjedno radno vrijeme",
      "TIMEZONE_LABEL": "Odaberite vremensku zonu",
      "UPDATE": "Ažuriraj postavke radnog vremena",
      "TOGGLE_AVAILABILITY": "Omogući radno vrijeme za ovaj sandučić",
      "UNAVAILABLE_MESSAGE_LABEL": "Poruka o nedostupnosti za posjetitelje",
      "TOGGLE_HELP": "Ako omogućite radno vrijeme, live chat widget prikazivat će dostupne sate čak i kada su svi agenti offline. Izvan radnog vremena posjetitelje možete upozoriti porukom i obrascem prije chata.",
      "DAY": {
        "ENABLE": "Omogući dostupnost za ovaj dan",
        "UNAVAILABLE": "Nedostupno",
        "HOURS": "sati",
        "VALIDATION_ERROR": "Vrijeme početka mora biti prije vremena završetka.",
        "CHOOSE": "Odaberi"
      },
      "ALL_DAY": "Cijeli dan",
      "SAVE_TO_ALL": "Spremi u sve sandučiće",
      "SAVE_TO_ALL_TITLE": "Kopiraj radno vrijeme",
      "SAVE_TO_ALL_CONFIRM": "Postavke iz ovog obrasca (preklopka dostupnosti, poruka izvan ureda, vremenska zona i radno vrijeme) bit će kopirane u sve ostale sandučiće osim e-mail i telefonskih sandučića. Jeste li sigurni da želite nastaviti?",
      "SAVE_TO_ALL_CANCEL": "Odustani",
      "SAVE_TO_ALL_YES": "Da, kopiraj u sve",
      "SAVE_TO_ALL_SUCCESS": "Radno vrijeme uspješno kopirano u sve ostale sandučiće",
      "SAVE_TO_ALL_ERROR": "Kopiranje radnog vremena u ostale sandučiće nije uspjelo"
    },
    "PHONE": {
      "TITLE": "Postavke telefona",
      "SUBTITLE": "Konfigurirajte koji će se pozivi prikazivati pod ovim sandučićem.",
      "UPDATE": "Spremi postavke",
      "EDIT": {
        "SUCCESS_MESSAGE": "Postavke telefona ažurirane",
        "ERROR_MESSAGE": "Ažuriranje postavki telefona nije uspjelo"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Telefonski brojevi",
        "SUBTITLE": "Unesite telefonske brojeve koji pripadaju ovom sandučiću.",
        "PLACEHOLDER": "+385123908635",
        "ADD": "Dodaj telefonski broj"
      }
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Postavite IMAP podatke",
      "NOTE_TEXT": "Da biste omogućili SMTP, konfigurirajte IMAP.",
      "UPDATE": "Ažuriraj IMAP postavke",
      "TOGGLE_AVAILABILITY": "Omogući IMAP konfiguraciju za ovaj sandučić",
      "TOGGLE_HELP": "Omogućavanje IMAP-a omogućuje primanje e-maila",
      "EDIT": {
        "SUCCESS_MESSAGE": "IMAP postavke su uspješno ažurirane",
        "ERROR_MESSAGE": "Nije moguće ažurirati IMAP postavke"
      },
      "ADDRESS": {
        "LABEL": "Adresa",
        "PLACE_HOLDER": "Adresa (npr. imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Prijava",
        "PLACE_HOLDER": "Prijava"
      },
      "PASSWORD": {
        "LABEL": "Lozinka",
        "PLACE_HOLDER": "Lozinka"
      },
      "ENABLE_SSL": "Omogući SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Ponovno autorizirajte svoj Microsoft račun"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Postavite SMTP podatke",
      "UPDATE": "Ažuriraj SMTP postavke",
      "TOGGLE_AVAILABILITY": "Omogući SMTP konfiguraciju za ovaj sandučić",
      "TOGGLE_HELP": "Omogućavanje SMTP-a omogućuje slanje e-maila",
      "EDIT": {
        "SUCCESS_MESSAGE": "SMTP postavke su uspješno ažurirane",
        "ERROR_MESSAGE": "Nije moguće ažurirati SMTP postavke"
      },
      "ADDRESS": {
        "LABEL": "Adresa",
        "PLACE_HOLDER": "Adresa (npr. smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Prijava",
        "PLACE_HOLDER": "Prijava"
      },
      "PASSWORD": {
        "LABEL": "Lozinka",
        "PLACE_HOLDER": "Lozinka"
      },
      "DOMAIN": {
        "LABEL": "Domena",
        "PLACE_HOLDER": "Domena"
      },
      "ENCRYPTION": "Šifriranje",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Način provjere OpenSSL-a",
      "AUTH_MECHANISM": "Autentifikacija"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "Isporučivost e-pošte (DNS)",
      "SUB_TITLE": "SPF, DKIM, DMARC i MX zapise za {domain} provjeravamo svaki radni dan. Kada nešto uzrokuje da poslužitelji primatelja odbijaju vaše odgovore ili ih svrstavaju u neželjenu poštu, administratori dobivaju e-poštu s uputom za ispravak.",
      "RUN": "Pokreni provjeru",
      "RUN_SUCCESS": "DNS provjera je završena",
      "RUN_ERROR": "DNS provjeru nije bilo moguće pokrenuti, pokušajte ponovno",
      "NOT_CHECKED": "Još nije provjereno.",
      "CHECKED_AT": "Zadnja provjera: {time}.",
      "DNS_UNAVAILABLE": "Zadnja provjera nije dobila odgovor od imenskih poslužitelja domene. Rezultat u nastavku potječe iz prethodne provjere.",
      "SENDER": {
        "SMTP": "Odgovori se šalju preko {host}.",
        "PLATFORM": "Odgovori se šalju preko naših poslužitelja e-pošte."
      },
      "STATUS": {
        "OK": "Svi zapisi su u redu",
        "WARNING": "Neki zapisi mogli bi biti bolji",
        "ERROR": "Odgovori možda neće stići do primatelja",
        "UNKNOWN": "Nepoznato"
      },
      "SEVERITY": {
        "ERROR": "Problem",
        "WARNING": "Upozorenje"
      },
      "FIX": "Riješite to ovim DNS zapisom:",
      "RECORD_TYPE": "Vrsta",
      "RECORD_HOST": "Naziv",
      "RECORD_VALUE": "Vrijednost",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "SPF zapis nedostaje",
          "DESCRIPTION": "Domena ne navodi koji poslužitelji smiju slati njezinu e-poštu. Mnogi poslužitelji tada vaše odgovore smatraju neželjenom poštom. Dodajte SPF zapis koji dopušta {sender}."
        },
        "spf_multiple": {
          "TITLE": "Domena ima {count} SPF zapisa",
          "DESCRIPTION": "Domena smije imati samo jedan SPF zapis. Ako ih je više, poslužitelji primatelja zanemaruju SPF i često odbijaju poruke. Spojite ih u jedan zapis."
        },
        "spf_not_authorized": {
          "TITLE": "SPF ne dopušta poslužitelj koji šalje vaše odgovore",
          "DESCRIPTION": "Vaši odgovori šalju se preko {sender}, ali ga SPF zapis domene ne navodi. Trenutni zapis: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "SPF zapis zahtijeva previše DNS upita",
          "DESCRIPTION": "Poslužitelji primatelja prestaju provjeravati SPF nakon {limit} DNS upita, ali do {sender}, koji šalje vaše odgovore, dolazi se tek nakon {lookups}. Vaši odgovori ne prolaze SPF. Premjestite {sender} na početak zapisa i uklonite include unose koje domena više ne koristi."
        },
        "spf_lookups_others": {
          "TITLE": "Neki pošiljatelji u SPF zapisu prelaze ograničenje upita",
          "DESCRIPTION": "SPF zapis zahtijeva {lookups} DNS upita, a poslužitelji primatelja staju nakon {limit}. Vaši odgovori se provjeravaju na vrijeme i prolaze, ali pošta ovih pošiljatelja ne prolazi SPF: {senders}. Uklonite include unose koje domena više ne koristi."
        },
        "spf_malformed": {
          "TITLE": "SPF zapis je neispravan",
          "DESCRIPTION": "Poslužitelji primatelja ne mogu pročitati SPF zapis domene pa on ne štiti vaše odgovore. Problem je u: {terms}. Zamijenite zapis ispravljenim."
        },
        "dkim_missing": {
          "TITLE": "DKIM potpis nije postavljen",
          "DESCRIPTION": "Nismo pronašli DKIM ključ na {selectors}. Bez njega vaši odgovori nisu potpisani i češće završavaju u neželjenoj pošti. Uključite DKIM potpisivanje za domenu kod svog pružatelja e-pošte."
        },
        "dmarc_missing": {
          "TITLE": "DMARC zapis nedostaje",
          "DESCRIPTION": "Veliki pružatelji e-pošte poput Gmaila i Microsofta očekuju DMARC zapis. Bez njega vaši odgovori češće završavaju u neželjenoj pošti."
        },
        "dmarc_fails": {
          "TITLE": "DMARC nalaže primateljima da odbace vaše odgovore",
          "DESCRIPTION": "DMARC pravilo domene je „{policy}”, a vaši odgovori ne prolaze ni SPF ni DKIM, pa ih primatelji odbijaju ili premještaju u neželjenu poštu. Ispravite SPF i DKIM navedene gore."
        },
        "dmarc_blocks_platform": {
          "TITLE": "DMARC blokira odgovore poslane preko naših poslužitelja e-pošte",
          "DESCRIPTION": "Ovaj sandučić šalje odgovore preko naših poslužitelja e-pošte, ali je DMARC pravilo domene „{policy}”, pa ih primatelji odbijaju ili premještaju u neželjenu poštu. Postavite SMTP vlastitog poslužitelja e-pošte za ovaj sandučić."
        },
        "mx_missing": {
          "TITLE": "Domena nema MX zapis",
          "DESCRIPTION": "Bez MX zapisa nitko ne može slati e-poštu na domenu, pa vaši klijenti ne mogu odgovoriti na vaše poruke."
        }
      }
    },
    "NOTE": "Napomena: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Avatar web stranice",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar je uspješno izbrisan",
              "ERROR_MESSAGE": "Došlo je do pogreške, pokušajte ponovno"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Naziv web stranice",
          "PLACE_HOLDER": "Unesite naziv web stranice (npr. Acme Inc)",
          "ERROR": "Unesite valjani naziv web stranice"
        },
        "WELCOME_HEADING": {
          "LABEL": "Naslov dobrodošlice",
          "PLACE_HOLDER": "Pozdrav!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Slogan dobrodošlice",
          "PLACE_HOLDER": "Jednostavno nam se obratite. Pitajte nas bilo što ili podijelite svoje mišljenje."
        },
        "REPLY_TIME": {
          "LABEL": "Vrijeme odgovora",
          "IN_A_FEW_MINUTES": "Za nekoliko minuta",
          "IN_A_FEW_HOURS": "Za nekoliko sati",
          "IN_A_DAY": "U roku jednog dana"
        },
        "WIDGET_COLOR_LABEL": "Boja widgeta",
        "WIDGET_BUBBLE_POSITION_LABEL": "Položaj oblačića widgeta",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Maksimalna visina nepročitanih poruka (px)",
          "PLACE_HOLDER": "Bez ograničenja",
          "HELP_TEXT": "Ograničite maksimalnu visinu skočnog prozora nepročitanih poruka u pikselima. Ostavite prazno za zadano ponašanje (bez ograničenja)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Vrsta oblačića widgeta",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Čavrljajte s nama",
          "LABEL": "Naslov oblačića widgeta",
          "PLACE_HOLDER": "Čavrljajte s nama"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Ažuriraj postavke widgeta",
          "API": {
            "SUCCESS_MESSAGE": "Postavke widgeta su uspješno ažurirane",
            "ERROR_MESSAGE": "Nije moguće ažurirati postavke widgeta"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Pretpregled",
          "SCRIPT": "Skripta"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Lijevo",
          "RIGHT": "Desno"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standardno",
          "EXPANDED_BUBBLE": "Prošireni oblačić"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Zadano",
        "CHAT": "Chat"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Obično odgovara za nekoliko minuta",
        "IN_A_FEW_HOURS": "Obično odgovara za nekoliko sati",
        "IN_A_DAY": "Obično odgovara u roku jednog dana"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Započnite razgovor",
        "CHAT_INPUT_PLACEHOLDER": "Unesite svoju poruku"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Online smo",
          "OFFLINE": "Trenutačno nismo online"
        },
        "USER_MESSAGE": "Bok",
        "AGENT_MESSAGE": "Pozdrav"
      },
      "BRANDING_TEXT": "Pokreće JARABOT",
      "SCRIPT_SETTINGS": "\n      window.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Drugi pružatelji"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Web stranica",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "EMAIL": "Email",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "API kanal",
      "PHONE": "SIP telefon",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    }
  }
}
